<template>
  <collapse-portlet v-if="entity.uuid" title="Share"
                    icon="fa fa-share-alt"
                    :expanded="false"
                    :always-show-actions="true">
    <template #portlet_actions>
      <button type="button" class="btn btn-icon btn-ss"
              title="Copy Player Link to Clipboard"
              @click="() => copyPlayerLinkToClipboard(entity)">
        <i class="la la-link" />
      </button>
      <button type="button" class="btn btn-icon btn-ss"
              title="Copy embed link to clipboard"
              @click="() => copyEmbedToClipboard(entity)">
        <i class="la la-code" />
      </button>
      <button v-if="entity.feed_xml_file_url"
              type="button"
              class="btn btn-icon btn-ss"
              title="Copy RSS link to clipboard"
              @click="() => copyRSSToClipboard(entity)">
        <i class="la la-rss" />
      </button>
      <button type="button" class="btn btn-icon btn-ss"
              title="Share on Facebook"
              @click="() => shareOnFacebook(entity)">
        <i class="socicon-facebook" />
      </button>
      <button type="button" class="btn btn-icon btn-ss"
              title="Share on Twitter"
              @click="() => shareOnTwitter(entity)">
        <i class="socicon-twitter" />
      </button>
      <button type="button" class="btn btn-icon btn-ss"
              title="Share on WhatsApp"
              @click="() => shareOnWhatsapp(entity)">
        <i class="socicon-whatsapp" />
      </button>
    </template>
    <share :item="entity" :is-feed="isFeed" />
  </collapse-portlet>
</template>

<script>
import CollapsePortlet from 'VueComponents/CollapsePortlet.vue';
import Share from 'VuePartials/App/Item/Share';
import SocialShareMixin from 'VueMixins/SocialShareMixin';

export default {
  components: {
    CollapsePortlet,
    Share,
  },
  mixins: [SocialShareMixin],
  props: {
    entity: {
      type: Object,
      required: true,
    },
    isFeed: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mounted() {
    this.initSocial();
  },
};
</script>
